import fromPairs from 'lodash/fromPairs';
import { LinkTrackingData } from './LinkTracking';

/** Converts a LinkTrackingData object into a set of data-attributes to be applied to an element */
export const renderLinkTrackingAttributes = (
  clickTracking: LinkTrackingData = {},
): Record<string, string> =>
  fromPairs<string>(
    Object.entries(clickTracking).map(([key, value]) => [
      `data-${camelToKebab(key)}`,
      renderValue(value),
    ]),
  );

/** Takes a camelCased string likeThisThing and returns kebab-case like-this-thing. */
const camelToKebab = (text: string) => text.replace(/[A-Z]/g, it => `-${it.toLowerCase()}`);

/** Takes an arbitrary value from a LinkTrackingData object and converts it to a string */
const renderValue = (value: LinkTrackingData[keyof LinkTrackingData]) => {
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};
